import script from "./AtividadeObjetivosInput.vue?vue&type=script&setup=true&lang=js"
export * from "./AtividadeObjetivosInput.vue?vue&type=script&setup=true&lang=js"

import "./AtividadeObjetivosInput.vue?vue&type=style&index=0&id=3dbaf8e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dbaf8e9"]])

export default __exports__